var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:['zg-section', {
    [`zg-section--background-${_vm.background}`]: _vm.background,
    'zg-section--no-padding': _vm.noPadding,
    'zg-section--no-top-padding': _vm.noTopPadding,
    'zg-section--no-bottom-padding': _vm.noBottomPadding,
    'zg-section--no-x-padding': _vm.noXPadding,
    'zg-section--no-y-padding': _vm.noYPadding,
    'zg-section--base-x-padding': _vm.baseXPadding,
    'zg-section--base-y-padding': _vm.baseYPadding,
    'zg-section--medium-x-padding': _vm.mediumXPadding,
    'zg-section--medium-y-padding': _vm.mediumYPadding,
    'zg-section--extra-x-padding': _vm.extraXPadding,
    'zg-section--extra-y-padding': _vm.extraYPadding,
    'zg-section--double-x-padding': _vm.doubleXPadding,
    'zg-section--double-y-padding': _vm.doubleYPadding
  }]},[_c('div',{staticClass:"zg-section__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }